import axios from 'axios';
import { APP_API_URL } from 'utils';
import { baseClient } from '../_api';

const sessionClient = axios.create({
  baseURL: `${APP_API_URL}/api/auth`,
  validateStatus: status => status < 300 || status === 401 || status === 409 || status === 429,
});

sessionClient.interceptors.request.use(config => {
  const token = localStorage.getItem('otpToken');
  const locale = localStorage.getItem('locale');

  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }
  if (locale) {
    config.headers.locale = locale;
  }

  return config;
});

export const getOTPToken = async payload => {
  const response = await baseClient.post('/get_otp_token/', { ...payload });
  if (response.data && response.data.needAgreement) {
    const error = { needAgreement: true };
    throw error;
  }
  return response;
};

// sessionClient
export const bindPhone = phone => sessionClient.post('/bind_phone/', { phone });
export const resendOTPToken = () => sessionClient.post('/resend_otp/');
export const getJWTToken = payload => sessionClient.post('/get_token/', { ...payload });
export const increaseInvitationCodeClicks = salesCode =>
  axios.post(`${APP_API_URL}/user_invitation/increase_invitation_code_clicks/${salesCode}/`);
